import React from 'react';
import {Container,  Flex, Text, Box, Link } from '@chakra-ui/react';

import { awards } from "../DATABASE/awards";

function ResearchAwards() {
    return (
    <>

        <Container maxW="1000px" py={5}>
            <Flex direction="column" align="left">
                <Text fontSize="25px" fontWeight="bold" textAlign="center">
                        Awards, Recognitions and Mentions,{" "}
                    <Link href="/">
                        <Text as="span" color="blue.600" fontStyle="italic" fontWeight="bold" textDecoration="underline">
                            Dr. Burak Kantarci 
                        </Text>
                    </Link>
                </Text>
            </Flex>
        </Container>

        <Container maxW="800px" py={5} centerContent>

            {/* Grants List */}
            {awards.map((awards, index) => (
                <Box 
                    key={index} 
                    p={4} 
                    borderWidth="1px" 
                    borderRadius="md" 
                    boxShadow="md" 
                    bg="white" 
                    w="100%" 
                    mt={3}
                >
                    {/* Title & Date Layout */}
                    <Flex justify="space-between" align="center" wrap="wrap">
                        <Text fontWeight="bold" flex="1" minW="60%">
                            {awards.title}
                        </Text>
                        <Text fontWeight="bold" fontStyle="italic" color="gray.600" minW="20%" textAlign="right">
                            {awards.date}
                        </Text>
                    </Flex>

                    {/* Description */}
                    <Text mt={2}>{awards.text}</Text>
                    {awards.link ?  (<Link href={awards.link} style={{ color: 'blue' }} target="_blank"><u>for more information</u></Link>) : null}
                    
                </Box>
            ))}
        </Container>
      
    </>
    );
  }


  export default ResearchAwards;